import { render, staticRenderFns } from "./Cards.vue?vue&type=template&id=67f04b84&scoped=true"
import script from "./Cards.vue?vue&type=script&lang=ts"
export * from "./Cards.vue?vue&type=script&lang=ts"
import style0 from "./Cards.vue?vue&type=style&index=0&id=67f04b84&prod&scoped=true&lang=css"
import style1 from "./Cards.vue?vue&type=style&index=1&id=67f04b84&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f04b84",
  null
  
)

export default component.exports